import { route } from "typesafe-react-router";

export const testRoutes = {
    error: route("test", "error"),
    index: route("test"),
};
